/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const onUpdateUserInfoById = /* GraphQL */ `
  subscription OnUpdateUserInfoById($id: ID!) {
    onUpdateUserInfoById(id: $id) {
      id
      scraping
      trial
      email
      customerId
      stripeAccount
      stripeParentAccount
      createdAt
      updatedAt
      profile {
        id
        name
        phone
        address
        createdAt
        updatedAt
      }
      order {
        items {
          id
          userId
          amount
          metadata
          createdAt
          updatedAt
        }
        nextToken
      }
      shop {
        items {
          id
          userId
          shopId
          createdAt
          updatedAt
          shop {
            id
            name
            domain
            spider
            link
            createdAt
            updatedAt
            owner
          }
        }
        nextToken
      }
      buyma {
        items {
          id
          userId
          kaiinId
          buyma
          accessCode
          endedAt
          approved
          subAccount
          createdAt
          updatedAt
        }
        nextToken
      }
      conf {
        id
        scraping
        buymanager
        image
        base
        createdAt
        updatedAt
      }
    }
  }
`;
export const onUpdateProfileById = /* GraphQL */ `
  subscription OnUpdateProfileById($id: ID!) {
    onUpdateProfileById(id: $id) {
      id
      name
      phone
      address
      createdAt
      updatedAt
    }
  }
`;
export const onCreateShop = /* GraphQL */ `
  subscription OnCreateShop {
    onCreateShop {
      id
      name
      domain
      spider
      link
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onUpdateShop = /* GraphQL */ `
  subscription OnUpdateShop {
    onUpdateShop {
      id
      name
      domain
      spider
      link
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onDeleteShop = /* GraphQL */ `
  subscription OnDeleteShop {
    onDeleteShop {
      id
      name
      domain
      spider
      link
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onCreateBrand = /* GraphQL */ `
  subscription OnCreateBrand {
    onCreateBrand {
      id
      brand
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onUpdateBrand = /* GraphQL */ `
  subscription OnUpdateBrand {
    onUpdateBrand {
      id
      brand
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onDeleteBrand = /* GraphQL */ `
  subscription OnDeleteBrand {
    onDeleteBrand {
      id
      brand
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onCreateCategory = /* GraphQL */ `
  subscription OnCreateCategory {
    onCreateCategory {
      id
      name
      sex
      important
      normal
      japanese
      foreign
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onUpdateCategory = /* GraphQL */ `
  subscription OnUpdateCategory {
    onUpdateCategory {
      id
      name
      sex
      important
      normal
      japanese
      foreign
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onDeleteCategory = /* GraphQL */ `
  subscription OnDeleteCategory {
    onDeleteCategory {
      id
      name
      sex
      important
      normal
      japanese
      foreign
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onCreateColor = /* GraphQL */ `
  subscription OnCreateColor {
    onCreateColor {
      id
      name
      key
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onUpdateColor = /* GraphQL */ `
  subscription OnUpdateColor {
    onUpdateColor {
      id
      name
      key
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onDeleteColor = /* GraphQL */ `
  subscription OnDeleteColor {
    onDeleteColor {
      id
      name
      key
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onCreateTranslateApi = /* GraphQL */ `
  subscription OnCreateTranslateApi {
    onCreateTranslateApi {
      id
      translate
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onUpdateTranslateApi = /* GraphQL */ `
  subscription OnUpdateTranslateApi {
    onUpdateTranslateApi {
      id
      translate
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onDeleteTranslateApi = /* GraphQL */ `
  subscription OnDeleteTranslateApi {
    onDeleteTranslateApi {
      id
      translate
      createdAt
      updatedAt
      owner
    }
  }
`;
